var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common_contents_wrap", attrs: { id: "bbs" } },
    [
      _c("h2", [_vm._v("BBS")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "bbs_form_wrap" }, [
        _c("div", { staticClass: "bbs_form" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.postBBS($event)
                }
              }
            },
            [
              _c("p", [
                _c("label", { attrs: { for: "name" } }, [_vm._v("名前")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputName,
                      expression: "inputName"
                    }
                  ],
                  attrs: { id: "name", type: "text", name: "" },
                  domProps: { value: _vm.inputName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputName = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", [
                _c("label", { attrs: { for: "title" } }, [_vm._v("件名")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputTitle,
                      expression: "inputTitle"
                    }
                  ],
                  attrs: { id: "title", type: "text", name: "" },
                  domProps: { value: _vm.inputTitle },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputTitle = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", [
                _c("label", { attrs: { for: "message" } }, [_vm._v("本文")]),
                _vm._v(" "),
                _c("span", { staticClass: "force_color" }),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputMessage,
                      expression: "inputMessage"
                    }
                  ],
                  attrs: { id: "message", name: "", required: "" },
                  domProps: { value: _vm.inputMessage },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputMessage = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm._m(1)
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "post_list" },
        _vm._l(_vm.postList, function(postItem, postKey) {
          return _c("li", { staticClass: "post_wrap" }, [
            _c("div", { staticClass: "post_countets" }, [
              _c("h4", [
                _vm._v("\n\t\t\t\t\t" + _vm._s(postItem.title) + "\n\t\t\t\t")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "bbs_txt" }, [
                _vm._v(_vm._s(postItem.message))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bbs_detail" }, [
                _c("p", [
                  _c("span", [_vm._v("投稿者：" + _vm._s(postItem.name))]),
                  _vm._v(" "),
                  _c("span", [_vm._v("投稿日：" + _vm._s(postItem.date))])
                ])
              ])
            ])
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", {}, [
      _vm._v("\n\t\tキリ番報告はこちらから♪"),
      _c("br"),
      _vm._v(
        "\n\t\t他にも管理人ＡＲＡＩへのご意見・ご要望など自由にカキコしてください( ´∀｀)"
      ),
      _c("br"),
      _vm._v("\n\t\t以下のような荒らしは"),
      _c("span", { staticClass: "force_color" }, [_vm._v("！！絶対禁止！！")]),
      _vm._v("です。"),
      _c("br"),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("・下ネタや誹謗・中傷ネタの投稿")]),
        _vm._v(" "),
        _c("li", [_vm._v("・「○○するだけでお金がもらえる」のような書き込み")]),
        _vm._v(" "),
        _c("li", [_vm._v("・マナーの悪い書き込み")]),
        _vm._v(" "),
        _c("li", [_vm._v("・その他管理人が不適切と判断した記事の投稿")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("input", { attrs: { type: "submit", value: "カキコ" } }),
      _vm._v(" "),
      _c("input", { attrs: { type: "reset", value: "リセット" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }